import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import formatDate from "../../utils";

function Ott() {
  const [ott, setOtt] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);
  const [data, setData] = useState({ ottId: "", name: "", password: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    setIsSubmitting(true);
    e.preventDefault();
    try {
      const response = await fetch("http://fundoramaa.co.in//api/v1/ott", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();
      setResponse(result);
      setIsSubmitting(false);
      setOtt((prevOtt) => [result.data, ...prevOtt]);

      const closeButton = document.querySelector('[data-bs-dismiss="modal"]');
      if (closeButton) {
        closeButton.click();
      }
    } catch (error) {
      setIsSubmitting(false);
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get("http://fundoramaa.co.in//api/v1/ott");
        if (response.data && Array.isArray(response.data.data)) {
          setOtt(response.data.data);
          console.log(response.data.data);
        } else {
          console.error("Unexpected response format:", response.data);
          setOtt([]);
        }
      } catch (error) {
        console.error("Error fetching ott:", error);
        setOtt([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  return (
    <>
      <Header />

      <div class="modal fade" id="addModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content rounded-4">
            <div className="end-0 position-absolute z-1">
              <button
                type="button"
                class="border-0 bg-transparent mt-1"
                data-bs-dismiss="modal"
              >
                <i className="bi bi-x fs-2 text-white circle-md bg-primary rounded-circle"></i>
              </button>
            </div>
            <div class="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="card-body p-3">
                  <h2 className="lh-1 mb-4">Add OTT</h2>
                  <div className="row g-3 mt-4">
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        OTT ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="ottId"
                        value={data.ottId}
                        onChange={handleChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        OTT Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control mt-1"
                        placeholder=""
                        name="name"
                        value={data.name}
                        onChange={handleChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="mt-2 col-lg-6 col-12">
                      <label>
                        Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        className="form-control mt-1"
                        placeholder=""
                        name="password"
                        value={data.password}
                        onChange={handleChange}
                        required
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg mt-5 w-100 rounded-3 fs-5 text-white"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting ..." : "Submit"}
                  </button>
                  <button
                    type="button"
                    data-bs-dismiss="modal"
                    className="d-none"
                  ></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-4">
        <div className="d-flex align-items-center">
          <a
            data-bs-toggle="modal"
            data-bs-target="#addModal"
            class="btn btn-dark px-4 rounded-3 me-5"
          >
            <span className="mx-2">
              Add OTT <i className="bi bi-file-post ms-2"></i>
            </span>
          </a>
        </div>
      </div>

      <section className="pb-7 mt-4 mb-3">
        <div className="container">
          {loading ? (
            <div class="spinner-border" role="status"></div>
          ) : (
            <>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">User Details</th>
                    <th scope="col">Date / Time</th>
                  </tr>
                </thead>
                <tbody>
                  {ott
                    .sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    )
                    .map((ott, index) => (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td>
                          ID : {ott._id} <br />
                          OTT ID : {ott.ottId} <br />
                          Name : {ott.name}
                        </td>
                        <td className="text-uppercase">
                          {formatDate(ott.createdAt)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </section>
    </>
  );
}

export default Ott;
